import type { FC } from 'react';

import { Box, NavLink, PageGrid, Stack } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { RegistrationFooterRendering } from '@sitecore/types/RegistrationFooter';

const RegistrationFooter: FC = () => {
  const { f } = useContent<RegistrationFooterRendering>();

  return (
    <Box backgroundColor="backgroundPrimary" paddingY="3">
      <PageGrid>
        <PageGrid.Item gridColumn="1/-1">
          <Stack direction="row" alignX="end">
            <NavLink href={f(`privacyStatementLink.value.href`)} variant="secondary">
              {f('privacyStatementLink.value.text')}
            </NavLink>
          </Stack>
        </PageGrid.Item>
      </PageGrid>
    </Box>
  );
};

export default RegistrationFooter;
